import firebase from "firebase";
import "firebase/storage";

//learnpointbyamit@gmail.com
// const firebaseConfig = {
//   apiKey: "AIzaSyCIp2IugV1otQQfEjKgRGC5-jj3mBuP52s",
//   authDomain: "chromind-app.firebaseapp.com",
//   databaseURL: "https://chromind-app.firebaseio.com",
//   projectId: "chromind-app",
//   storageBucket: "chromind-app.appspot.com",
//   messagingSenderId: "307471843258",
//   appId: "1:307471843258:web:7ae86bb8cdc75ce90da783",
// };

//camtranslate07@gmail.com
// var firebaseConfig = {
//   apiKey: "AIzaSyCWoF2BcoYVPKCM3pBkR5jPODd5wPLGqrc",
//   authDomain: "appbrowser-967e4.firebaseapp.com",
//   projectId: "appbrowser-967e4",
//   storageBucket: "appbrowser-967e4.appspot.com",
//   messagingSenderId: "772351633091",
//   appId: "1:772351633091:web:aca4c1eebd0b56e41c2476",
//   measurementId: "G-NVMBJ3GEFW",
// };

//xitij
var firebaseConfig = {
  apiKey: "AIzaSyDb_D1euhTaJD0xlpjeZ6JC2lEhh1Nu1GI",
  authDomain: "app-browser-e140f.firebaseapp.com",
  databaseURL: "https://app-browser-e140f.firebaseio.com",
  projectId: "app-browser-e140f",
  storageBucket: "app-browser-e140f.appspot.com",
  messagingSenderId: "651905386267",
  appId: "1:651905386267:web:e44fe7039ff6e4a5a0f5be",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
export const storage = firebase.app().storage();
